import { fetchApiDataV2, likeHandlerShorts } from "../../utils/utils";

export const getVerticalShowsList = async (appInfo, showIdentifier) => {
  const api = `verticalShows/${showIdentifier}`;
  return await fetchApiDataV2(appInfo, api);
};

export const likeHandler = async (id, liked, appInfo) => {
  const api = `like/video`;
  const data = {
    id,
    liked
  };
  return await likeHandlerShorts(api, data, appInfo);
};